export default __webpack_public_path__ + "static/media/Heavy Jovian Cape.d8c30aa0.jpg";